const normalizar = (valor) => String(valor || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toUpperCase();

export const isGrupoFeeSpeaker = (item) => {
    const produto = item?.produto || {};
    return String(produto.codigo || '').trim() === '3016'
        || normalizar(produto.nome) === 'FEE SPEAKER';
};

/** Speaker é somente informativo para a WBS do cliente: não tem fornecedor Access. */
export const aplicarRegraFeeSpeaker = (subitem) => ({
    ...subitem,
    fornecedor: null,
    fornecedorpagamento: { id: 'cliente', nome: 'Cliente' },
});
